import { render, staticRenderFns } from "./PtrBreadcrumb.vue?vue&type=template&id=c264ab28&scoped=true&"
import script from "./PtrBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./PtrBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./PtrBreadcrumb.vue?vue&type=style&index=0&id=c264ab28&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c264ab28",
  null
  
)

export default component.exports